import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';

import {
  applyTransporterFilters,
  createTransporter,
  editTransporter,
  fetchTransporters,
  initiateTransporterCreate,
  initiateTransporterEdit,
  setNewTransporterValue,
} from '../../actions';
import { CreateFieldsColumns } from './CreateFieldsColumns';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import { selectNewTransporter, selectTransporters } from '../../selectors';
import { selectWorks } from '../../../Api/selectors';
import { REQUEST_TRANSPORTER_CREATE, REQUEST_TRANSPORTER_EDIT, TRANSPORTER_FIELD_TYPES } from '../../constants';
import LoadingField from '../../../../containers/App/Components/LoadingField/LoadingField';

const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class CreateTransporterModalComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (this.props.transporterId) {
      this.props.initEdit();
    } else {
      this.props.init();
    }
  }
  componentDidUpdate(prevProps, prevState) {}

  save() {
    let dto = {};

    for (let i in this.props.values) {
      if (TRANSPORTER_FIELD_TYPES.includes(i) && this.props.values?.[i]) {
        dto[i] = this.props.values?.[i];
      }
    }

    if (this.props.transporterId) {
      dto['id'] = this.props.transporterId;
      this.props.edit(dto, result => {
        if (result?.id) {
          this.props.setTransporterFilter();
          this.reset();
        }
      });
      return;
    }

    this.props.create(dto, result => {
      if (result?.id) {
        this.props.setTransporterFilter();

        this.reset();
      }
    });
  }

  reset() {
    this.props.init();
    return this.props.onClose();
  }

  render() {
    if (this.props.work) {
      return (
        <ModalComponent size={'modal-lg'}>
          <LoadingField />
          <LoadingField />
          <LoadingField />
          <LoadingField />
          <LoadingField />
          <LoadingField />
          <LoadingField />
          <LoadingField />
        </ModalComponent>
      );
    }

    return (
      <ModalComponent size={'modal-lg'} onClose={() => this.reset()}>
        <CreateFieldsColumns />
        <div className="d-flex gap-2 justify-content-end mt-3">
          <ButtonComponent style={'ButtonSoftEdit'} onClick={() => this.save()}>
            {this.props.transporterId ? this.lbl('edit') : this.lbl('save')}
          </ButtonComponent>
          <ButtonComponent style={'ButtonSoftDelete'} onClick={() => this.reset()}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }
}

CreateTransporterModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  reset: PropTypes.func,
  onNextModal: PropTypes.func,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_TRANSPORTER_CREATE, REQUEST_TRANSPORTER_EDIT]),
    transporters: selectTransporters(),
    values: selectNewTransporter(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    initEdit() {
      dispatch(initiateTransporterEdit(ownProps.transporterId));
    },
    init() {
      dispatch(initiateTransporterCreate());
    },
    create(dto, callback) {
      dispatch(createTransporter(dto, callback));
    },
    edit(dto, callback) {
      dispatch(editTransporter(ownProps.transporterId, dto, callback));
    },
    setTransporterFilter: () => {
      dispatch(applyTransporterFilters());
    },
    setValue(name, value) {
      dispatch(setNewTransporterValue(name, value));
    },
    fetchTransporters(callback) {
      dispatch(fetchTransporters(callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CreateTransporterModal = compose(withConnect, withRouter, injectIntl)(CreateTransporterModalComp);
